"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormApi = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _http = require("../utils/http");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FormApi = /*#__PURE__*/function () {
  function FormApi() {
    (0, _classCallCheck2.default)(this, FormApi);
  }

  (0, _createClass2.default)(FormApi, null, [{
    key: "getForm",
    value: function getForm(id) {
      if (!id) {
        return;
      }

      return _http.http.get('/api/form', {
        params: {
          id: id
        }
      }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "getFormList",
    value: function getFormList() {
      return _http.http.get('/api/form/list').then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "getAllFormList",
    value: function getAllFormList() {
      return _http.http.get('/api/form/dropdown').then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "deleteForm",
    value: function deleteForm(id) {
      return _http.http.delete('api/form', {
        params: {
          id: id
        }
      }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "saveForm",
    value: function saveForm(name, collection, jsonConfig) {
      return _http.http.post('/api/form', {
        name: name,
        collection: collection,
        jsonConfig: jsonConfig
      }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "editForm",
    value: function editForm(id, name, jsonConfig) {
      return _http.http.put('/api/form', {
        id: id,
        name: name,
        jsonConfig: jsonConfig
      }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "getList",
    value: function getList(authId) {
      var matches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var data = {
        authId: authId,
        matches: matches
      };
      return _http.http[_http.httpMethod]('/api/db/list', _http.httpMethod === 'post' ? data : {
        params: _objectSpread(_objectSpread({}, data), {}, {
          matches: JSON.stringify(data.matches || [])
        })
      }).then(function (res) {
        return res.data || [];
      });
    }
  }, {
    key: "getPage",
    value: function getPage(data) {
      return _http.http[_http.httpMethod]('/api/db/page', _http.httpMethod === 'post' ? data : {
        params: _objectSpread(_objectSpread({}, data), {}, {
          matches: JSON.stringify(data.matches || [])
        })
      }).then(function (res) {
        return res.data || [];
      });
    }
  }, {
    key: "getData",
    value: function getData(authId, _id) {
      var data = {
        authId: authId,
        matches: [{
          name: '_id',
          method: 'eq',
          value: _id
        }]
      };
      return _http.http[_http.httpMethod]('/api/db/list', _http.httpMethod === 'post' ? data : {
        params: _objectSpread(_objectSpread({}, data), {}, {
          matches: JSON.stringify(data.matches || [])
        })
      }).then(function (res) {
        return res && res.data && res.data[0];
      });
    }
  }, {
    key: "addData",
    value: function addData(authId, data) {
      return _http.http.post('/api/db', {
        authId: authId,
        data: data
      }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "editData",
    value: function editData(authId, data) {
      return _http.http.put('/api/db', {
        authId: authId,
        data: data
      }).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "deleteData",
    value: function deleteData(authId, _id) {
      return _http.http.delete('/api/db', {
        params: {
          authId: authId,
          data: {
            _id: _id
          }
        }
      }).then(function (res) {
        return res.data;
      });
    }
  }]);
  return FormApi;
}();

exports.FormApi = FormApi;